import React from "react";
import ChartErrorBoundary from "../charts/shared/error/ChartErrorBoundary";
import NoDataMessage from "../charts/shared/layout/NoDataMessage";
import styles from "./Dashboard.module.css";

type Props = {
  hasData: boolean;
  chartName: string;
  noDataMessage: string;
  noDataSuggestion?: string;
  children: React.ReactNode;
};

const AnalysisChartWrapper = ({
  hasData,
  chartName,
  noDataMessage,
  noDataSuggestion,
  children,
}: Props) => {
  return (
    <div className={styles.mobileChartWrapper}>
      {hasData ? (
        <ChartErrorBoundary chartName={chartName}>{children}</ChartErrorBoundary>
      ) : (
        <NoDataMessage message={noDataMessage} suggestion={noDataSuggestion} />
      )}
    </div>
  );
};

export default AnalysisChartWrapper;
